var BaseViews = require('../../base');
require('./product-zoom-toggle/product-zoom-toggle.scss');
var ProductZoomToggle = BaseViews.LayoutView.extend({
    template: require('./product-zoom-toggle/product-zoom-toggle.html'),
    className: 'fmcy-product-zoom-toggle fmcy-product-zoom-toggle',
    events: {
        click: 'onToggle'
    },
    initialize: function(options) {
        var self = this;
        this.options = options;
        // Opposites because its a toggle.
        this.enabledText = 'Disable Drag';
        this.disabledText = 'Enable Drag';

        this.setToggleText();
        this.model.on('change:zoomEnabled', function() {
            self.setToggleText();
        });
    },
    setToggleText: function() {
        if (this.model.get('zoomEnabled') === true) {
            this.model.set('zoomToggleText', this.enabledText);
        } else {
            this.model.set('zoomToggleText', this.disabledText);
        }
        this.render();
    },
    onToggle: function() {
        if (this.model.get('zoomEnabled') === true) {
            this.model.set('zoomEnabled', false);
        } else {
            this.model.set('zoomEnabled', true);
        }
        this.setToggleText();
    }
});
module.exports = ProductZoomToggle;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/menu-item-expanded/product-zoom-toggle.js
 **/